import { DialogResolution } from 'components/shared/modals/CASTDialog/CASTDialogProvider';
import { CASTDialogProps } from 'components/shared/modals/CASTDialog/types';
import { ComponentProps, ComponentType, createContext } from 'react';

export type OnSubmitFunction<T> = (args?: any) => Promise<T>;

export type ShowDialog = <TComponent extends ComponentType<any>>(
  options: CASTDialogProps<TComponent>
) => Promise<
  ComponentProps<TComponent> extends { onSubmit?: OnSubmitFunction<infer R> }
    ? DialogResolution<R>
    : DialogResolution<undefined>
>;

export type CASTDialogContextValue = {
  showDialog: ShowDialog;
  cancelDialog: () => void;
  confirmDialog: (data: any) => void;
};

// See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-774430643
export default createContext<CASTDialogContextValue>(undefined as any);
